<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/FormsHandbook/table-headers'

import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTableFormsHandbook',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
